import { render, staticRenderFns } from "./MerchantProductSku.vue?vue&type=template&id=72e7bbd5&scoped=true&"
import script from "./MerchantProductSku.vue?vue&type=script&lang=js&"
export * from "./MerchantProductSku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e7bbd5",
  null
  
)

component.options.__file = "MerchantProductSku.vue"
export default component.exports